import '../Login-Screen/Login.css';
import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useScrollOrNavigate from "../../Hooks/useScrollOrNavigate.js";
import SystemDataService from "../../Services/SystemDataService.js";

import Footer from "../../Utils/Footer/footer-component";
import LazyOnView from "../../Utils/LazyLoading/LazyOnView.js";
import Layout from "../../Utils/Navbar/navbar-layout-component.js";

import Contact from "../Contact-screen/Contact.js";
import ReviewList from "../../Components/review-list-component.js";
import MapSection from "../../Utils/Sections/section-map-component.js";
import FaqSection from "../../Utils/Sections/section-faq-component.js";
import TrustSection from "../../Utils/Sections/section-trust-component.js";
import ContentSection from "../../Utils/Content/content-section-component.js";
import MetricsSection from "../../Utils/Sections/section-metrics-component.js";
import QuickCallSection from "../../Utils/Sections/section-quick-call-component.js";
import ProductListSection from "../../Utils/Sections/section-product-list-component.js";
import CategoryListSection from "../../Utils/Sections/section-category-list-component.js";
import SpecialsBannerSection from "../../Utils/Sections/section-specials-banner-component.js";
import CategoriesBentoSection from "../../Utils/Sections/section-categories-bento-component.js";
import InfoBarSection from "../../Utils/Sections/section-info-bar-component.js";

import { getLandingData } from "../../Public/landing-data.js";
import { LoadingAnimation } from "../../Utils/Progress/progress-component.js";
import OurWorkSection from "../../Utils/Sections/section-our-work-component.js";
import ProductFinderSection from "../../Utils/Sections/section-product-finder-component.js";
import ShopHeroSection from "../../Utils/Sections/section-shop-hero-component.js";
import PopUpPromotion from "../../Utils/Modal/pop-up-modal-component.js";
import LandingHeroSection from './landing-hero-section.js';
import ServicesSection from '../Services-screen/ServicesSection.js';
import ContactFormLightweight from '../../Utils/Forms/ContactForm/contact-form-lightweight-component.js';


function Landing({ topBanner = null }) {
    const navigate = useNavigate();
    const scrollOrNavigate = useScrollOrNavigate();

    const systemData = useSelector((state) => state.systemData);
    const rawProducts = useSelector((s) => s.cart?.products || []);
    const LandingData = useMemo(() => getLandingData(systemData.language), [systemData.language]);
    const { heroSection, infoCardsSection, contentSection, trustSection, imageGridSection, seo, specialsBannerSection, categoriesBentoSection } = LandingData;
    const bentoCategories = useMemo(() => systemData.categories?.filter(c => c.status !== false), [systemData.categories]);

    const allProducts = useMemo(() =>
        (Array.isArray(rawProducts) ? rawProducts : []).filter(p => p.status !== 'DISABLED' && p.showInStore !== false),
        [rawProducts]);

    const categoryProductGroups = useMemo(() => {
        const cats = systemData.categories || [];
        return cats
            .filter(cat => !cat.restock)
            .map(cat => ({
                cat,
                items: allProducts.filter(p => (p.categoryIds || []).includes(cat.id) || p.category?.id === cat.id),
            }))
            .filter(({ items }) => items.length > 0);
    }, [systemData.categories, allProducts]);

    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        SystemDataService.getReviews().then(setReviews);
    }, []);

    return (
        <div>
            <Layout seo={seo}>
                {topBanner}
                <PopUpPromotion />
                <LoadingAnimation fullscreen={false} />

                <div className="flex w-full h-full justify-center align-middle overflow-x-hidden transition-all delay-200">
                    <section className="bg-white dark:bg-gray-900 transition-all delay-200 w-full">

                        <LandingHeroSection heroContent={heroSection} />

                        {/* <ShopHeroSection/> */}


                        {/* Info Bar */}
                        <InfoBarSection />

                        {/* Specials Banner */}
                        {/* <SpecialsBannerSection sectionData={specialsBannerSection} images={specialsBannerSection.images} mobileImages={specialsBannerSection.mobileImages} /> */}

                        {/* Categories Bento */}
                        {/* <CategoriesBentoSection sectionData={categoriesBentoSection} categories={bentoCategories} maxItems={categoriesBentoSection.maxCategories} /> */}

                        {/* <ProductFinderSection/> */}

                        {/* 3. Categories */}
                        {/* <CategoryListSection /> */}

                        <div
                            id="services"
                            className="w-full relative bg-white dark:bg-black border-t border-primary-50 dark:border-neutral-800 overflow-hidden">
                            <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[radial-gradient(#003366_1px,transparent_1px)] [background-size:40px_40px]"></div>
                            <div className="relative z-10">
                                <ServicesSection
                                    isHeadline={true}
                                    showMore={true}
                                    showMoreText="View All Services"
                                    onShowMore={() => navigate('/services')}
                                    loading={false}
                                />
                            </div>
                        </div>

                        {/* 6. Products — one section per category, content section injected at midpoint */}
                        {/* <div className="bg-white divide-y divide-gray-50">
                            {(() => {
                                const mid = Math.ceil(categoryProductGroups.length / 2);
                                return categoryProductGroups.map(({ cat, items }, index) => (
                                    <div key={cat.id}>
                                        <ProductListSection
                                            title={cat.name}
                                            subtitle={cat.description}
                                            items={items}
                                            limit={8}
                                            showMore={true}
                                            href={`/categories/${cat.slug}`}
                                        />
                                        {index === mid - 1 && (
                                            <div className="max-w-[1400px] mx-auto px-4 py-4">
                                                <ContentSection
                                                    label={contentSection.label}
                                                    title={contentSection.title}
                                                    subtitle={contentSection.subtitle}
                                                    backgroundImage={contentSection.backgroundImage}
                                                    buttonText={contentSection.buttonText}
                                                    onButtonClick={() => navigate('/categories')}
                                                    className="rounded-2xl overflow-hidden"
                                                />
                                            </div>
                                        )}
                                    </div>
                                ));
                            })()}
                        </div> */}



                        {/* 4. Trust */}
                        {/* <div className="">
                            <TrustSection trustSection={trustSection} />
                        </div> */}

                        <OurWorkSection />

                        {/* 5. Metrics */}
                        {/* <div className="flex w-full py-20 justify-center flex-col align-middle bg-primary-700 rounded-xl lg:rounded-none">
                            <LazyOnView rootMargin="-100px 0px -50px 0px" threshold={0.1} delay={0}>
                                <MetricsSection />
                            </LazyOnView>
                        </div> */}


                        {/* 7. Image Grid */}
                        {/* <ImageGrid items={imageGridSection.items} /> */}

                        {/* 9. Map */}
                        {/* <MapSection /> */}

                        {/* 10. Content */}
                        <ContentSection
                            title={<div className="whitespace-pre-line">{contentSection.title}</div>}
                            subtitle={contentSection.subtitle}
                            backgroundImage={contentSection.backgroundImage}
                            backgroundColor={'bg-white'}
                            buttonText={contentSection.buttonText}
                            onButtonClick={() => console.log('Clicked Content Section')}
                            disclaimer={contentSection.disclaimer}
                        />





                        {/* 12. About */}
                        {/* <LazyOnView rootMargin="-100px 0px -50px 0px" threshold={0.1} delay={0}>
                            <About />
                        </LazyOnView> */}

                        {/* 13. Services */}


                        {/* 11. Reviews */}
                        <div className="w-full bg-gray-100">
                            <ReviewList reviews={reviews} useElegant={true} />
                        </div>



                        {/* 2. Info Cards */}
                        {/* <div className="w-full flex justify-center lg:px-0 relative overflow-visible">
                            <div className="relative w-full z-10">
                                <LazyOnView rootMargin="-400px 0px -50px 0px" threshold={0.1} delay={0}>
                                    <InfoCardsSection infoCardsSection={infoCardsSection} />
                                    <div className="flex justify-center px-6 md:mt-0 md:absolute md:left-1/2 md:-bottom-6 md:-translate-x-1/2 z-20">
                                        <ButtonSecondary
                                            size='lg'
                                            onClick={(e) => scrollOrNavigate(e, 'shop', '/shop')}
                                            className="uppercase tracking-widest font-black shadow-xl"
                                        >
                                            Shop Now
                                        </ButtonSecondary>
                                    </div>
                                </LazyOnView>
                            </div>
                        </div> */}


                        {/* <QuickCallSection /> */}

                        {/* Free estimate CTA strip */}
                        <div className="w-full bg-white py-14 px-4">
                            <div className="max-w-2xl mx-auto text-center">
                                <h2 className="text-3xl lg:text-4xl font-black text-primary-800 mb-2 uppercase tracking-tight">
                                    Get a Free Estimate
                                </h2>
                                <p className="text-primary-600 text-sm mb-8 font-medium">
                                    Tell us about your project — we'll get back to you quickly.
                                </p>
                                <ContactFormLightweight onSuccess={() => navigate('/thank-you')} />
                            </div>
                        </div>

                        {/* 14. FAQ */}
                        <div className="w-full bg-slate-50">
                            <div className="w-full max-w-7xl mx-auto px-4">
                                <LazyOnView rootMargin="-400px 0px -50px 0px" threshold={0.1} delay={0}>
                                    <FaqSection />
                                </LazyOnView>
                            </div>
                        </div>

                        {/* 15. Contact */}
                        <LazyOnView rootMargin="-100px 0px -50px 0px" threshold={0.1} delay={0}>
                            <Contact />
                        </LazyOnView>

                    </section>
                </div>
            </Layout>
            <Footer />
        </div>
    );
}

export default Landing;
